export interface DetailedError extends Error {
    status: number;
    app_version: string;
    code?: string | number;
    errorPrefix?: string | undefined;
}

export enum AdjustmentErrors {
    ADJUSTMENT_NOT_IMPLEMENTED = 'ADJUSTMENT_NOT_IMPLEMENTED',
    RESERVATION_SOURCE_EXCLUDED = 'RESERVATION_SOURCE_EXCLUDED',
    INVALID_ARGUMENTS = 'INVALID_ARGUMENTS',
    POLICY_VALIDATION_FAILED = 'POLICY_VALIDATION_FAILED',
    FOLIO_FAILED = 'FOLIO_FAILED',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PENDING_BALANCE = 'PENDING_BALANCE',
    DISCOUNT_COUPON_ERROR = 'DISCOUNT_COUPON_ERROR',
    TIME_FRAME_EXPIRED = 'TIME_FRAME_EXPIRED',
}

export enum ErrorsPrefix {
    EXCEPTION = 'EX',
    IDV_FAILED = 'IF',
    NETWORK_ERROR = 'NE',
    LEGACY_TOKEN_ERROR = 'TE',
    LEGACY_TOKEN_NOT_FOUND = 'TN',
    RESERVATION_CANCELLED = 'CX',
    RESERVATION_IN_BLOCKLISTS = 'RB',
    RESERVATION_FRANCHISED = 'RF',
    RESERVATION_NOT_PUBLIC = 'RN',
    TRIP_API_ERROR = 'TA',
    //Related to AdjustmentErrors
    ADJUSTMENT_NOT_IMPLEMENTED = 'ANI',
    RESERVATION_SOURCE_EXCLUDED = 'ASE',
    INVALID_ARGUMENTS = 'AIA',
    POLICY_VALIDATION_FAILED = 'AVF',
    FOLIO_FAILED = 'AFF',
    PAYMENT_ERROR = 'APE',
    PAYMENT_FAILED = 'APF',
    PENDING_BALANCE = 'APB',
    DISCOUNT_COUPON_ERROR = 'ACE',
    TIME_FRAME_EXPIRED = 'AFE',
}
